<template>
  <div>
    <v-row class="ma-0 pa-3">
      <v-col cols="12" class="cap-cont pa-3">
        <label>Número da linha</label>
        <p>{{value.phoneNumber | ifBlank('-')}}</p>
      </v-col>

      <v-col cols="4" class="cap-cont pa-3">
        <label>Operadora</label>
        <p>{{value.operator | ifBlank('-')}}</p>
      </v-col>

      <v-col cols="4" class="cap-cont pa-3">
        <label>Cartão com APN</label>
        <p>{{value.isApn | brYesNo}}</p>
      </v-col>

      <v-col cols="4" class="cap-cont pa-3">
        <label>Cartão pré-pago</label>
        <p>{{value.isPrePaid | brYesNo}}</p>
      </v-col>

      <v-col cols="12" class="cap-cont pa-3">
        <label>Comentários</label>
        <p>{{value.comments || '-'}}</p>
      </v-col>

      <v-col cols="6" class="cap-cont pa-3">
        <label>Último IMEI</label>
        <p>{{value.lastHbClientId || '-'}}</p>
      </v-col>

      <v-col cols="6" class="cap-cont pa-3">
        <label>Último HB</label>
        <p>{{value.lastHbTimestamp || '-'}}</p>
      </v-col>

      <v-col cols="6" class="cap-cont pa-3">
        <label>Criado</label>
        <p>{{value.createdAt | moment}}</p>
      </v-col>

      <v-col cols="6" class="cap-cont pa-3">
        <label>Atualizado</label>
        <p>{{value.updatedAt | moment}}</p>
      </v-col>
    </v-row>

    <v-divider/>

    <ODataTable :items="value.clients" :spec="spec"/>

  </div>
</template>

<script>
import ODataTable from 'oderon-vue/cpts/ODataTable'

export default {
  props: ['value'],
  components: {ODataTable},
  data() {
    return {
      spec: [
        {t: 'Módulo'  , d: 'id'},
        {t: 'Org'     , d: 'organization.name'},
        {t: 'Veículo|', d: 'vehicleCode'},
        {t: 'FW|'     , d: 'currentFirmwareVersion'},
        {t: 'Lote|'   , d: 'batchNumber'}
      ]
    }
  }
}
</script>

<style>
</style>
